import { statusValues, paymentStatus } from "./constants.ts";

export const calculateDiscountedPrice = (price, discount) => {
  if (!discount || discount === "0") return price;
  return Number(price) - Number(price) * (Number(discount) / 100);
};
export const filterProducts = (
  products,
  priceFilters, // Array of price ranges, e.g., ["0-50", "50-100"]
  colorFilters, // Array of selected colors, e.g., ["red", "green"]
  materialFilters, // Array of selected materials, e.g., ["PLA", "TPU"]
  ratingFilters, // Array of selected ratings, e.g., ["1 star", "2 stars"]
  customFilters // Boolean for filtering custom items, e.g., [true] or [false]
) => {
  if (!products || products.length === 0) return [];
  return products.filter((product) => {
    const price = calculateDiscountedPrice(product.price, product.discount);
    const filterPrice = priceFilters.split("-").map(Number);

    // Filter by Price Range
    const matchesPrice =
      filterPrice.length < 2 ||
      (price >= filterPrice[0] && price <= filterPrice[1]);

    // Filter by Color
    const matchesColor =
      colorFilters.length === 0 || colorFilters.includes(product.colorCode);

    // Filter by Material
    const matchesMaterial =
      materialFilters.length === 0 ||
      materialFilters.includes(product.typeName);

    // Filter by Rating
    const matchesRating =
      ratingFilters.length === 0 ||
      ratingFilters.some((rating) => {
        const ratingValue = parseInt(rating);

        return parseInt(product.rating) === ratingValue;
      });

    // Filter by Custom Property
    const matchesCustom =
      customFilters.length === 0 || (customFilters[0] && product.customize);
    return (
      matchesPrice &&
      matchesColor &&
      matchesMaterial &&
      matchesRating &&
      matchesCustom
    );
  });
};

export const getPriceRange = (products) => {
  if (!products || products.length === 0)
    return [
      { value: 0, label: "Min" },
      { value: 0, label: "Max" },
    ];

  const prices = products.map((product) =>
    calculateDiscountedPrice(product.price, product.discount)
  );

  const min = Math.min(...prices);
  const max = Math.max(...prices);
  return [
    { value: min, label: "Min" },
    { value: max, label: "Max" },
  ];
};

export const getUserIdFromToken = (token: string | null): string => {
  if (!token) return "0";

  try {
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3) throw new Error("Invalid token format");

    const decodedPayload = JSON.parse(atob(tokenParts[1])); // Decode payload

    return decodedPayload.nameid || null;
  } catch (error) {
    return "0";
  }
};

export const getUserRoleFromToken = (token: string | null): string => {
  if (!token) return "0";

  try {
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3) throw new Error("Invalid token format");

    const decodedPayload = JSON.parse(atob(tokenParts[1])); // Decode payload

    return decodedPayload.role || null;
  } catch (error) {
    return "0";
  }
};

export const getStyle = (status: string) => {
  if ("red" === status) {
    return { backgroundColor: "#d11e1e21", color: "red" };
  } else if ("green" === status) {
    return { backgroundColor: "#0080001c", color: "green" };
  } else if ("orange" === status) {
    return { backgroundColor: "#ffa5002b", color: "orange" };
  } else if ("blue" === status) {
    return { backgroundColor: "#00478026", color: "#1735c7" };
  }
};
export const getStatusColor = (status): any => {
  switch (status) {
    case statusValues.NEW:
      return getStyle("blue");
    case statusValues.IN_PROGRESS:
      return getStyle("orange");
    case statusValues.DELIVERED:
      return getStyle("green");
    case statusValues.CANCELED:
      return getStyle("red");
    case paymentStatus.PAID:
      return getStyle("green");
    case paymentStatus.PENDING:
      return getStyle("orange");
    case paymentStatus.REFUNDED:
      return getStyle("blue");
    case paymentStatus.UNPAID:
      return getStyle("red");
    case paymentStatus.DECLINED:
      return getStyle("red");
    default:
      return getStyle("orange");
  }
};
